import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deeplink-einvoice',
  templateUrl: './deeplink-einvoice.component.html',
  styleUrls: ['./deeplink-einvoice.component.scss']
})
export class DeeplinkEinvoiceComponent implements OnInit {

  connect = false;

  constructor() { }

  ngOnInit(): void {
  }

  onRenew(): void {
    this.connect = true;

    setTimeout(() => {
      this.toMiniapp();
    }, 1000);
  }

  toMiniapp(): void {
    window.location.href = 'mbbank://?ad_dp=marketplaceapp&code=PHZTOMOTEK';
  }

}
